// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a2848481","453":"18fc1b22","455":"1cfe43b9","977":"e219779f"}[chunkId] + ".chunk.js";
};